import { createSlice } from "@reduxjs/toolkit";
import {
  CommunityForumInitialStatus,
  GetCommunityForumData,
  GetSingleCommunityForumData,
} from "../../../types/communityForum/communityForum";
import {
  createCommunityForumAsync,
  getAllCommunityForumAsync,
  singleCommunityForumAsync,
  updateCommunityForumAsync,
} from "./communityForumApi";

const initialState: CommunityForumInitialStatus<
  GetCommunityForumData,
  GetSingleCommunityForumData
> = {
  loading: false,
  manageLoading: false,
  communityForumList: [],
  singleCommunityForumData: null,
  countCommunityForum: 0,
};

const communityForumDataSlice = createSlice({
  name: "admin-community-Forum",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // create
    builder
      .addCase(createCommunityForumAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(createCommunityForumAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(createCommunityForumAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // get all
    builder
      .addCase(getAllCommunityForumAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllCommunityForumAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.communityForumList = action.payload.data;
        state.countCommunityForum = action.payload.length;
      })
      .addCase(getAllCommunityForumAsync.rejected, (state) => {
        state.loading = false;
        state.communityForumList = [];
        state.countCommunityForum = 0;
      });

    // update
    builder
      .addCase(updateCommunityForumAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateCommunityForumAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateCommunityForumAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // single
    builder
      .addCase(singleCommunityForumAsync.pending, (state) => {
        state.manageLoading = true;
        state.singleCommunityForumData = null;
      })
      .addCase(singleCommunityForumAsync.fulfilled, (state, action) => {
        state.manageLoading = false;
        state.singleCommunityForumData = action.payload;
      })
      .addCase(singleCommunityForumAsync.rejected, (state) => {
        state.manageLoading = false;
        state.singleCommunityForumData = null;
      });
  },
});

export default communityForumDataSlice;
